import React, { useEffect, useState } from "react";
import iconEvent2026 from "../../../../assets/images/Event-2026/icon-open-event.png";
import { CloseOutlined } from "@ant-design/icons";
import { useLocation, useHistory } from "react-router-dom";
import { ID_TAB_EVENT_2024, ROUTER_EVENT_2024, ID_TAB_EVENT_NEW_YEAR, TAB_EVENT_NEW_YEAR } from "@config/constants/helper";
import { PATHS } from "@config/constants";
import {
  getCookieShowPopupEvent,
  isLoggedIn,
  setEventCookie,
} from "@utils/cookie";
import PopupIntro from "../components/Popup/PopupIntro";
import Winner from '../components/Winner/Winner';
import { MiniGameProvider } from "../store";
// import FinishedEvent from "./FinishedEvent";
// import PopupPrizeWinner from "./PopupPrizeWinner";
// import PopupEnfishedEvent2025 from "./PopupEnfishedEvent2024";
// import PopupIntroduceEvent from "./PopupIntroduceEvent";

export default function LayoutEvent({ statusEvent = {} }) {
  const [isShowEvent, setIsShowEvent] = useState(true);
  const location = useLocation();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [openPrizeUser, setOpenPrizeUser] = useState(false);
  const [openPrize, setOpenPrize] = useState(false);
  const [isShowPopup, setIsShowPopup] = useState(false);


  useEffect(() => {
    // let isRouterEvent = false;
    // TAB_EVENT_NEW_YEAR.forEach((item) => {
    //   if (location.pathname === `${PATHS.EVENT_2025}/${item.id}`) {
    //     isRouterEvent = true;
    //   }
    // });
    // if (isRouterEvent) {
    //   return setIsShowEvent(false);
    // }
    setIsShowEvent(true);
    const isLogin = isLoggedIn();

    const isShowPopupEvent = getCookieShowPopupEvent();
    const isShowPopupPrize = getCookieShowPopupEvent("hiddenPopupEventPrize");
    const isShowPopupWinner = getCookieShowPopupEvent("hiddenPopupEventWinner");
    const isShowPopupPrizeUser = getCookieShowPopupEvent(
      "hiddenPopupEventPrizeUser"
    ); // trúng thưởng của user

    if (!isShowPopupWinner && statusEvent.is_finished === 0 && statusEvent.is_show === 0) { // Hiển thị kết quả sau khi kết thúc event
      setIsShowPopup(true)
      setEventCookie("hiddenPopupEventWinner");
    }

    if (
      !isShowPopupEvent &&
      location.pathname !== PATHS.LOGIN_PAGE &&
      +statusEvent.is_show === 1
    ) {
      setOpen(true);
      setEventCookie();
    }

    if (!isShowPopupPrizeUser && isLogin && +statusEvent.is_finished === 1) {
      setOpenPrizeUser(true);
      setEventCookie("hiddenPopupEventPrizeUser");
    }
    if (
      !isShowPopupPrize &&
      location.pathname !== PATHS.LOGIN_PAGE &&
      +statusEvent.is_finished === 1
    ) {
      setOpenPrize(true);
      setEventCookie("hiddenPopupEventPrize");
    }
  }, [location.pathname, statusEvent.is_finished, statusEvent.is_show]);

  const handleClose = () => {
    setIsShowEvent(false);
  };

  const hanleToEvent = () => {
    if (statusEvent.is_finished === 1) {
      return null;
      // return history.push(`${PATHS.EVENT_2025}/${ID_TAB_EVENT_NEW_YEAR.congratulation}`);
    } else if (statusEvent.is_finished === 0 && statusEvent.is_show === 0) {
      setIsShowPopup(true)
      return;
    }
    history.push(`${PATHS.EVENT_WORLD_CUP_2026}/home`);
  };


  if (!isShowEvent || +statusEvent.is_finished === 1 || location.pathname === PATHS.LOGIN_PAGE || location.pathname.startsWith("/event-world-cup-2026")) {
    return null;
  }

  return (
    <div className="container-icon-main-event-2024">
      {/* <PopupIntro open={open} onCancel={() => setOpen(false)} /> */}
      {/* {statusEvent.is_finished ||
      location.pathname === PATHS.LOGIN_PAGE ? null : (
          <PopupIntroduceEvent open={open} setOpen={setOpen} handleToEvent={hanleToEvent}/>
        // <PopupComponents
        //   backgroundPopup={bgPopup}
        //   open={open}
        //   setOpen={setOpen}
        //   title={`¡Únete a la espectacular Navidad Explosiva recolectando Fósforos y Fuegos Artificiales para ganar fantásticos premios!`}
        //   // title={`Join the spectacular Navidad Explosiva race by collecting Matches and Firework Shells to win <span class="text-forcust-event">3 fantastic high-value prizes!</span>`}
        //   btnAction={{
        //     action: hanleToEvent,
        //     title: "¡Únete ahora!",
        //   }}
        //   description={`<div class="action-des-event-name">Inicia sesión diariamente para obtener GRATIS 3 Cajas Navideñas Normales donde puedes ganar <span class="text-forcust-event"> 10 Giftcards de S/.100!</span> Y alcanza la meta del Espectáculo de Fuegos Artificiales para desbloquear Súper Cajas Navideñas con más posibilidades de ganar.</div>`}
        // />
      )} */}

      {statusEvent.is_finished === 1 &&
        location.pathname !== PATHS.LOGIN_PAGE ? (
        <>
          {/* {openPrizeUser ? (
            <FinishedEvent setOpen={setOpenPrizeUser} open={openPrizeUser} />
          ) : null} */}
          {/* {openPrize ? (
            // <PopupPrizeWinner open={openPrize} setOpen={setOpenPrize} />
              <PopupEnfishedEvent2025 open={openPrize} setOpen={setOpenPrize} />
          ) : null} */}
        </>
      ) : null}
      <div className="position-relative zoom-in-out-box">
        <div
          className="close-event"
          style={{
            height: "35px",
            width: "35px",
            position: "absolute",
            right: 0,
          }}
          onClick={handleClose}
        >
        </div>
        <img
          src={iconEvent2026}
          alt="icon-event-2024"
          className="icon-event-2024"
          onClick={hanleToEvent}
        />
      </div>
      <PopupIntro open={open} onCancel={() => setOpen(false)} />
      <MiniGameProvider>
        <Winner
          isOpen={isShowPopup}
          setIsOpen={setIsShowPopup}
        />
      </MiniGameProvider>
      {/* <Winner isOpen={isShowPopup} setIsOpen={setIsShowPopup} /> */}
    </div >
  );
}
